import { createApp } from '@backstage/frontend-defaults';
import {
  OpenIdConnectApi,
  bitbucketAuthApiRef,
  atlassianAuthApiRef,
  ProfileInfoApi,
  BackstageIdentityApi,
  SessionApi,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import {
  createApiRef,
  createFrontendModule,
  configApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
  ApiBlueprint,
} from '@backstage/frontend-plugin-api';

const keycloakAuthApiRef = createApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>().with({
  id: 'auth.keycloak',
});

const keycloakAuthApi = ApiBlueprint.make({
  name: 'keycloak',
  params: defineParams =>
    defineParams({
      api: keycloakAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
        OAuth2.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          environment: configApi.getOptionalString('auth.environment'),
          provider: {
            id: 'oidc',
            title: 'Keycloak',
            icon: () => null,
          },
          defaultScopes: ['openid', 'profile', 'email'],
        }),
    }),
});

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
      <SignInPage
          {...props}
          providers={[
            'guest',
            {
              id: 'bitbucket-auth-provider',
              title: 'Bitbucket Cloud',
              message: 'Sign In using Bitbucket Cloud',
              apiRef: bitbucketAuthApiRef,
            },
            {
              id: 'keycloak-auth-provider',
              title: 'Keycloak',
              message: 'Sign In using Keycloak',
              apiRef: keycloakAuthApiRef,
            },
            {
              id: 'atlassian-auth-provider',
              title: 'Atlassian Cloud',
              message: 'Sign In using Atlassian',
              apiRef: atlassianAuthApiRef,
            }
          ]}
        />
      ),
  },
});

export default createApp({
  features: [
    // ...
    createFrontendModule({
      pluginId: 'app',
      extensions: [keycloakAuthApi, signInPage],
    }),
  ],
});